<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="researchDetail">

  <a (click)="share()">
    <img src="assets/share.png" alt="" style="width: 20px; position: absolute; right: 7%; top: 104px;">
  </a>

  <div class="container py-3">
    <div class="row justify-content-center">
      <h1 class="lifedi-color text-center mb-5">
        {{ researchDetail.RESEARCH_NAME }}
      </h1>
      <div class="col-lg-12 col-md-12 col-sm-12">
        <mat-card class="d-flex justify-content-between">
          <p class="text-left m-0">คำถามคัดกรอง</p>

          <img src="assets/other/check (black).png" alt="" style="width: 20px;">
        </mat-card>
      </div>
    </div>

    <div *ngFor="let item of researchWave; let i = index" class="my-5">
      <p class="text-left my-5">
        <span style="text-decoration: underline; font-size: x-large;">
          Wave {{ i+1 }}
        </span>
        <span *ngIf="item.type === 'age'" style="margin-left: 10px; font-size: large;">
          (ช่วงอายุ {{ item.start_year }} ปี {{ item.start_month }} เดือน - {{ item.end_year }} ปี {{ item.end_month }}
          เดือน)
        </span>
        <span *ngIf="item.type === 'time'" style="margin-left: 10px; font-size: large;">
          (ช่วงเวลา {{ item.start | date }} - {{ item.end | date }})
        </span>
      </p>
      <div class="row">
        <div *ngFor="let m of item.measures" class="col-lg-3 col-md-4 col-sm-6 mb-4">
          <lifedi-measure-card [data]="m.query_measure[0]" [researchMeasureStatus]="m.DONE" [researchID]="researchID"
            [start]="item.start" [waveID]="item.wave_id" [end]="item.end" [type]="type"></lifedi-measure-card>
        </div>
      </div>
    </div>
  </div>
</div>
